import { render, staticRenderFns } from "./TransferMoney.vue?vue&type=template&id=d64157d0&"
import script from "./TransferMoney.vue?vue&type=script&lang=js&"
export * from "./TransferMoney.vue?vue&type=script&lang=js&"
import style0 from "./TransferMoney.vue?vue&type=style&index=0&id=d64157d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports